import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Sheet from '../../components/Sheet'
import ActionBar from '../../components/ActionBar'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Alert from '@mui/material/Alert'

export default function CreateUser(props) {
    const { t } = useTranslation()
    const { showCreateUser, setShowCreateUser, fetchResource } = props
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')
    const [role, setRole] = useState('')
    const [badRole, setBadRole] = useState(false)
    const [badUsername, setBadUsername] = useState(false)
    const [badPassword, setBadPassword] = useState(false)
    const [badPasswordConfirm, setBadPasswordConfirm] = useState(false)
    const [passwordErrorMsg, setPasswordErrorMsg] = useState('')
    const [userNameError, setUserNameError] = useState('')
    const [showAlert, setShowAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')

    async function handleSubmit() {
        let [user, pass, passConf] = [username, password, passwordConfirm]

        // TODO: (IMPORTANT) Do this validation and special character validation on the server side
        user = user.trim().toLocaleLowerCase()
        pass = pass.trim()
        passConf = passConf.trim()

        if (!user) {
            setBadUsername(true)
            setUserNameError(t('users.usernameRequired'))
            return
        } else {
            setBadUsername(false)
        }
        if (user.length < 3) {
            setBadUsername(true)
            setUserNameError(t('users.usernameTooShort'))
            return
        } else {
            setBadUsername(false)
        }
        if (user.length > 255) {
            setBadUsername(true)
            setUserNameError(t('users.usernameTooLong'))
            return
        } else {
            setBadUsername(false)
        }
        if (!pass) {
            setBadPassword(true)
            setPasswordErrorMsg(t('users.passwordRequired'))
            return
        } else {
            setBadPassword(false)
        }
        if (pass.length < 6) {
            setBadPassword(true)
            setPasswordErrorMsg(t('users.passwordTooShort'))
            return
        } else {
            setBadPassword(false)
        }
        if (pass !== passConf) {
            setBadPasswordConfirm(true)
            setPasswordErrorMsg(t('users.passwordMismatch'))
            return
        } else {
            setBadPasswordConfirm(false)
        }
        if (!role) {
            setBadRole(true)
            return
        } else {
            setBadRole(false)
        }

        const createUser = await fetchResource({
            resource: 'users/create',
            body: {
                username: user,
                password: pass,
                role
            },
            blocking: true
        })

        if (createUser.error) {
            console.error(createUser.error)
            setShowAlert(true)
            setAlertMessage(createUser.error)
            return
        }

        window.location.reload(false)
        setShowCreateUser(false)
    }

    useEffect(() => {
        return () => {
            setUsername('')
            setUserNameError('')
            setBadUsername(false)
            setPassword('')
            setBadPassword(false)
            setPasswordConfirm('')
            setBadPasswordConfirm(false)
            setRole('')
        }
    }, [showCreateUser])

    useEffect(() => {
        showAlert &&
            setTimeout(() => {
                setShowAlert(false)
            }, 3000)
    }, [showAlert])

    return (
        <>
            {showAlert && (
                <Alert className='alert' severity='error' variant='filled'>
                    {alertMessage}
                </Alert>
            )}
            <Sheet
                open={showCreateUser}
                onClose={() => setShowCreateUser(false)}
                title={t('users.createTitle')}
                actions={
                    <ActionBar
                        cancel={{ label: t('common.cancel'), onClick: () => setShowCreateUser(false) }}
                        confirm={{ label: t('users.create'), onClick: handleSubmit }}
                    />
                }
            >
                {/* The old `minWidth: 350px` was wider than a 390px phone's content
                    box, so the box won and ate the popup's own left padding --
                    8px on the left against 32px on the right. The sheet sizes to
                    the screen instead, so the fields just run its full width. */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <TextField
                        autoComplete='off'
                        helperText={badUsername && userNameError}
                        error={badUsername}
                        fullWidth
                        required
                        id='username'
                        label={t('users.usernameLabel')}
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />
                    <TextField
                        autoComplete='off'
                        helperText={badPassword && passwordErrorMsg}
                        error={badPassword}
                        fullWidth
                        required
                        id='password'
                        label={t('users.passwordLabel')}
                        type='password'
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    <TextField
                        autoComplete='off'
                        helperText={badPasswordConfirm && passwordErrorMsg}
                        error={badPasswordConfirm}
                        fullWidth
                        required
                        id='password-confirm'
                        type='password'
                        label={t('users.confirmPasswordLabel')}
                        value={passwordConfirm}
                        onChange={e => setPasswordConfirm(e.target.value)}
                    />
                    <FormControl fullWidth>
                        <InputLabel> {t('users.roleLabel')} </InputLabel>
                        <Select
                            error={badRole}
                            required
                            labelId='select-role'
                            id='select-role'
                            value={role}
                            label={t('users.roleLabel')}
                            onClose={() => setTimeout(() => document.activeElement.blur())}
                            onChange={e => setRole(e.target.value)}
                        >
                            {/* TODO: Make this dynamic using role.js */}
                            <MenuItem value={1}> Admin </MenuItem>
                            <MenuItem value={2}> Sales </MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Sheet>
        </>
    )
}
